<section class="content tab-section d-flex">
  <div class="content-block flex-grow-1">
    <div class="tab-content flex-grow-1 d-flex flex-column ">
      <div class="flex-grow-1">
        <div class="noti-box d-flex " *ngFor="let item of notificationArr" [@fadeOut]>
          <div class="profile-img me-2" [appBackgroundImg]="item.profile_picture"></div>
          <div class="flex-grow-1">
            <h6 class="mb-0">{{item.title}}</h6>
            <div class="desc-t">{{item.message}}</div>
            <span class="menu-desc ">
              <i class="material-icons me-1">access_time</i> {{item.create_time}}
            </span>
          </div>
          <div class="d-flex align-items-center p-3 cursor-pointer">
            <img (click)="hideNotification(item?.id)" src="assets/images/icons/delete-icon.svg" alt="">
          </div>
        </div>

        <div class="mat-table__message" *ngIf="notificationArr.length==0">
          <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
        </div>
      </div>



      <div class="pagination-cont" *ngIf="notificationArr.length != 0">
        <div class="show-item">
          {{"COMMON.SIP" | translate}}
          <select class="form-control sel-op ms-2" (change)="onPageSizeChange($event)"
            [(ngModel)]="config.itemsPerPage">
            <option [value]="item" *ngFor="let item of pageSizeOptions">
              {{ item }}
            </option>
          </select>
        </div>
        <div class="page-c">
          <ngb-pagination [collectionSize]="count" [(page)]="config.currentPage" [pageSize]="config.itemsPerPage"
            [maxSize]="maxPaginationSize" (pageChange)="onPageChange($event)"></ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</section>